import { render, staticRenderFns } from "./Leumicard.vue?vue&type=template&id=fb666f78&scoped=true&"
import script from "./Leumicard.vue?vue&type=script&lang=js&"
export * from "./Leumicard.vue?vue&type=script&lang=js&"
import style0 from "./Leumicard.vue?vue&type=style&index=0&id=fb666f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb666f78",
  null
  
)

export default component.exports